module.exports = __webpack_public_path__ + "img/reports.ecdae849.svg";